"use strict";

document
  .querySelectorAll(".subscription-widget-block")
  .forEach(function (widget) {
    widget.classList.add("hide");
  });

let productType,
  blendsType,
  roastingProduct,
  groundType,
  quantity,
  deliverySchedule,
  productInfo,
  groundImage,
  deliveryScheduleImage,
  rotatingQuantity = ["(1) 12oz bag", "(1) 2lb bag", "(1) 5lb bag"],
  roastingQuantity = [],
  selling_plan,
  giftMessage,
  variantID;

const rotatingBlendSection = document.querySelector(".choose-rotating-blends"),
  roastingSection = document.querySelector(".choose-roasting"),
  groundSection = document.querySelector(".choose-ground"),
  rotatingquantitySection = document.querySelector(".choose-rotating-quantity"),
  roastingquantitySection = document.querySelector(".choose-roasting-quantity"),
  scheduleSection = document.querySelector(".choose-schedule"),
  summarySection = document.querySelector(".order-summary"),
  commonBtnClass = ".homepage-section-btn",
  commonHeadingClass = ".widget-block--grid-heading",
  select = document.getElementById("gift-select");

async function fetchProduct(handle) {
  try {
    const response = await fetch(`/products/${handle}.js`);
    const product = await response.json();
    return product;
  } catch (error) {
    console.error(error);
  }
}

document.querySelectorAll(".choose--product").forEach(function (selectionBtn) {
  selectionBtn.addEventListener("click", async function () {
    document.querySelectorAll(".choose--product").forEach(function (curr) {
      curr.classList.remove("selected");
    });

    selectionBtn.classList.add("selected");

    productType = selectionBtn.getAttribute("data-label");

    if (productType == "Rotating Selection") {
      if (!roastingSection.classList.contains("hide")) {
        roastingSection.classList.add("hide");
      }
      rotatingBlendSection.classList.remove("hide");

      window.scrollTo({
        top:
          rotatingBlendSection.offsetTop -
          document.getElementsByClassName("header-section")[0].offsetHeight,
        left:
          rotatingBlendSection.offsetTop -
          document.getElementsByClassName("header-section")[0].offsetHeight,
        behavior: "smooth",
      });

      chooseRotatingBlend();

      productInfo = await fetchProduct("doma-subscription");

      document
        .querySelectorAll(".subscription-widget-block .homepage-section-btn")
        .forEach(function (curr) {
          if (curr.classList.contains("selected")) {
            curr.classList.remove("selected");
            curr.innerText = "Select";
          }
        });
    } else {
      if (!rotatingBlendSection.classList.contains("hide")) {
        rotatingBlendSection.classList.add("hide");
      }

      roastingSection.classList.remove("hide");

      chooseRoasting();

      window.scrollTo({
        top:
          roastingSection.offsetTop -
          document.getElementsByClassName("header-section")[0].offsetHeight,
        left:
          roastingSection.offsetTop -
          document.getElementsByClassName("header-section")[0].offsetHeight,
        behavior: "smooth",
      });

      document
        .querySelectorAll(".subscription-widget-block .homepage-section-btn")
        .forEach(function (curr) {
          if (curr.classList.contains("selected")) {
            curr.classList.remove("selected");
            curr.innerText = "Select";
          }
        });
    }
  });
});

document
  .querySelector(".choose-rotating-blends .swap--section")
  .addEventListener("click", function () {
    document.querySelectorAll(".choose--product").forEach(function (curr) {
      curr.classList.remove("selected");
    });

    if (!rotatingBlendSection.classList.contains("hide")) {
      rotatingBlendSection.classList.add("hide");
    }

    roastingSection.classList.remove("hide");

    productType = "Specific Roasts";

    chooseRoasting();

    document
      .querySelectorAll(".subscription-widget-block .homepage-section-btn")
      .forEach(function (curr) {
        if (curr.classList.contains("selected")) {
          curr.classList.remove("selected");
          curr.innerText = "Select";
        }
      });
  });

document
  .querySelector(".choose-roasting .swap--section")
  .addEventListener("click", async function () {
    if (!roastingSection.classList.contains("hide")) {
      roastingSection.classList.add("hide");
    }
    rotatingBlendSection.classList.remove("hide");

    productType = "Rotating Selection";

    chooseRotatingBlend();

    productInfo = await fetchProduct("doma-subscription");

    document
      .querySelectorAll(".subscription-widget-block .homepage-section-btn")
      .forEach(function (curr) {
        if (curr.classList.contains("selected")) {
          curr.classList.remove("selected");
          curr.innerText = "Select";
        }
      });
  });

function chooseRotatingBlend() {
  for (let i = 0; i <= 2; i++) {
    document.querySelectorAll(
      `.choose-rotating-quantity ${commonHeadingClass}`
    )[i].innerText = rotatingQuantity[i];
  }

  rotatingBlendSection
    .querySelectorAll(`${commonBtnClass}`)
    .forEach(function (btn) {
      btn.addEventListener("click", function () {
        rotatingBlendSection
          .querySelectorAll(`${commonBtnClass}`)
          .forEach(function (curr) {
            if (curr.classList.contains("selected")) {
              curr.classList.remove("selected");
              curr.innerText = "Select";
            }
          });
        btn.classList.add("selected");
        btn.innerText = "Selected";

        blendsType = btn.parentNode.querySelector(
          `${commonHeadingClass}`
        ).innerText;

        groundSection.classList.remove("hide");

        chooseGround("rotating");

        window.scrollTo({
          top:
            groundSection.offsetTop -
            document.getElementsByClassName("header-section")[0].offsetHeight,
          left:
            groundSection.offsetTop -
            document.getElementsByClassName("header-section")[0].offsetHeight,
          behavior: "smooth",
        });

        if (
          groundType != null &&
          quantity != null &&
          deliverySchedule != null
        ) {
          orderSummary();
        }

        document.querySelector(
          ".subscription-order--summary-product--title"
        ).innerText = blendsType;
      });
    });
}

function chooseRoasting() {
  roastingSection
    .querySelectorAll(`${commonBtnClass}`)
    .forEach(async function (btn) {
      btn.addEventListener("click", async function () {
        roastingSection
          .querySelectorAll(`${commonBtnClass}`)
          .forEach(function (curr) {
            if (curr.classList.contains("selected")) {
              curr.classList.remove("selected");
              curr.innerText = "Select";
            }
          });

        btn.classList.add("selected");
        btn.innerText = "Selected";

        blendsType = btn.parentNode.querySelector(
          `${commonHeadingClass}`
        ).innerText;

        roastingProduct = btn.getAttribute("data-product-handle");

        if (groundSection.classList.contains("hide")) {
          groundSection.classList.remove("hide");
        }

        chooseGround("roasting");

        window.scrollTo({
          top:
            groundSection.offsetTop -
            document.getElementsByClassName("header-section")[0].offsetHeight,
          left:
            groundSection.offsetTop -
            document.getElementsByClassName("header-section")[0].offsetHeight,
          behavior: "smooth",
        });

        productInfo = await fetchProduct(`${roastingProduct}`);

        if (
          groundType != null &&
          quantity != null &&
          deliverySchedule != null
        ) {
          orderSummary();
        }

        document.querySelector(
          ".subscription-order--summary-product--title"
        ).innerText = blendsType;

        roastingQuantity = [];

        productInfo.options.forEach(function (option) {
          if (option.name == "Size") {
            option.values.forEach(function (value) {
              roastingQuantity.push(value);
            });
          }
        });

        for (let i = 0; i <= 2; i++) {
          document.querySelectorAll(
            `.choose-roasting-quantity ${commonHeadingClass}`
          )[i].innerText = roastingQuantity[i];
        }
      });
    });
}

function chooseGround(type) {
  groundSection.querySelectorAll(`${commonBtnClass}`).forEach(function (btn) {
    btn.addEventListener("click", function () {
      groundSection
        .querySelectorAll(`${commonBtnClass}`)
        .forEach(function (curr) {
          if (curr.classList.contains("selected")) {
            curr.classList.remove("selected");
            curr.innerText = "Select";
          }
        });
      btn.classList.add("selected");
      btn.innerText = "Selected";

      groundType = btn.parentNode.querySelector(
        `${commonHeadingClass}`
      ).innerText;
      groundImage = btn.getAttribute("data-image-src");

      if (type == "rotating") {
        roastingquantitySection.classList.add("hide");
        rotatingquantitySection.classList.remove("hide");

        rotatingquantitySelection();
        window.scrollTo({
          top:
            rotatingquantitySection.offsetTop -
            document.getElementsByClassName("header-section")[0].offsetHeight,
          left:
            rotatingquantitySection.offsetTop -
            document.getElementsByClassName("header-section")[0].offsetHeight,
          behavior: "smooth",
        });
      } else {
        rotatingquantitySection.classList.add("hide");
        roastingquantitySection.classList.remove("hide");

        roastingquantitySelection();
        window.scrollTo({
          top:
            roastingquantitySection.offsetTop -
            document.getElementsByClassName("header-section")[0].offsetHeight,
          left:
            roastingquantitySection.offsetTop -
            document.getElementsByClassName("header-section")[0].offsetHeight,
          behavior: "smooth",
        });
      }

      if (quantity != null && deliverySchedule != null) {
        orderSummary();
      }

      document
        .querySelector(".subscription-order--summary-option-image")
        .setAttribute("src", groundImage);
      document.querySelector(
        ".subscription-order--summary-option--title"
      ).innerText = groundType;
    });
  });
}

function rotatingquantitySelection() {
  rotatingquantitySection
    .querySelectorAll(`${commonBtnClass}`)
    .forEach(function (btn) {
      btn.addEventListener("click", function () {
        rotatingquantitySection
          .querySelectorAll(`${commonBtnClass}`)
          .forEach(function (curr) {
            if (curr.classList.contains("selected")) {
              curr.classList.remove("selected");
              curr.innerText = "Select";
            }
          });
        btn.classList.add("selected");
        btn.innerText = "Selected";

        quantity = btn.parentNode.querySelector(
          `${commonHeadingClass}`
        ).innerText;

        if (scheduleSection.classList.contains("hide")) {
          scheduleSection.classList.remove("hide");
        }

        selectSchedule();

        window.scrollTo({
          top:
            scheduleSection.offsetTop -
            document.getElementsByClassName("header-section")[0].offsetHeight,
          left:
            scheduleSection.offsetTop -
            document.getElementsByClassName("header-section")[0].offsetHeight,
          behavior: "smooth",
        });

        if (deliverySchedule != null) {
          orderSummary();
        }

        document.querySelector(
          ".subscription-order--summary-product--size"
        ).innerText = quantity;
      });
    });
}

function roastingquantitySelection() {
  roastingquantitySection
    .querySelectorAll(`${commonBtnClass}`)
    .forEach(function (btn) {
      btn.addEventListener("click", function () {
        roastingquantitySection
          .querySelectorAll(`${commonBtnClass}`)
          .forEach(function (curr) {
            if (curr.classList.contains("selected")) {
              curr.classList.remove("selected");
              curr.innerText = "Select";
              const heading = curr.parentElement.querySelector('.widget-block--grid-heading');
            if (heading && heading.textContent.trim() === "12 oz") {
              heading.classList.remove("chargeShipping"); // Remove 'chargeShipping' class
            }
            else{
               heading.classList.remove("nochargeShipping");
            }
            }
          });
        btn.classList.add("selected");
        if(btn){
        const heading = btn.parentElement.querySelector('.widget-block--grid-heading');
          if (heading && heading.textContent.trim() === "12 oz") {
            heading.classList.add("chargeShipping");
          }
          else{
            heading.classList.add("nochargeShipping");
          }
        }
        btn.innerText = "Selected";

        quantity = btn.parentNode.querySelector(
          `${commonHeadingClass}`
        ).innerText;

        if (scheduleSection.classList.contains("hide")) {
          scheduleSection.classList.remove("hide");
        }

        selectSchedule();

        window.scrollTo({
          top:
            scheduleSection.offsetTop -
            document.getElementsByClassName("header-section")[0].offsetHeight,
          left:
            scheduleSection.offsetTop -
            document.getElementsByClassName("header-section")[0].offsetHeight,
          behavior: "smooth",
        });

        if (deliverySchedule != null) {
          orderSummary();
        }

        document.querySelector(
          ".subscription-order--summary-product--size"
        ).innerText = quantity;
      });
    });
}

function selectSchedule() {
  scheduleSection.querySelectorAll(`${commonBtnClass}`).forEach(function (btn) {
    btn.addEventListener("click", function () {
      scheduleSection
        .querySelectorAll(`${commonBtnClass}`)
        .forEach(function (curr) {
          if (curr.classList.contains("selected")) {
            curr.classList.remove("selected");
            curr.innerText = "Select";
          }
        });
      btn.classList.add("selected");
      btn.innerText = "Selected";

      deliverySchedule = btn.parentNode.querySelector(
        `${commonHeadingClass}`
      ).innerText;
      deliveryScheduleImage = btn.getAttribute("data-image-src");

      if (summarySection.classList.contains("hide")) {
        summarySection.classList.remove("hide");

        orderSummary();
      }

      window.scrollTo({
        top:
          summarySection.offsetTop -
          document.getElementsByClassName("header-section")[0].offsetHeight,
        left:
          summarySection.offsetTop -
          document.getElementsByClassName("header-section")[0].offsetHeight,
        behavior: "smooth",
      });

      document
        .querySelector(".subscription-order--summary-schedule-image")
        .setAttribute("src", deliveryScheduleImage);
      document.querySelector(
        ".subscription-order--summary-schedule--title"
      ).innerText = deliverySchedule;

      switch (deliverySchedule) {
        case "Every Week":
          deliverySchedule = "Delivery every 1 Week";
          break;
        case "Every Two Weeks":
          deliverySchedule = "Delivery every 2 Weeks";
          break;
        case "Every Three Weeks":
          deliverySchedule = "Delivery every 3 Weeks";
          break;
        case "Every Month":
          deliverySchedule = "Delivery every 4 Weeks";
          break;
      }
      
    productInfo.selling_plan_groups.forEach(function (group) {
    if (group.name != "Subscribe and save") {
     group.selling_plans.forEach(function (plan) {
    let normalizedSchedule = deliverySchedule.toLowerCase();
    let normalizedPlanName = plan.name.toLowerCase();

    if (normalizedSchedule.endsWith("s")) {
      normalizedSchedule = normalizedSchedule.endsWith("s") ? normalizedSchedule.slice(0, -1) : normalizedSchedule;
      normalizedPlanName = normalizedPlanName.endsWith("s") ? normalizedPlanName.slice(0, -1) : normalizedPlanName;
    }

    if (normalizedPlanName === normalizedSchedule) {
       selling_plan = plan.id;
    }
    
  });
  }
});
    });
  });
}

function orderSummary() {
  if (productType == "Rotating Selection") {
    productInfo.variants.forEach(function (variant) {
      if (
        variant.option1 == quantity &&
        variant.option2 == groundType &&
        variant.option3.includes(blendsType)
      ) {
        variantID = variant.id;
        orderSummaryContent(variant.featured_image.src, variant.price);
      }
    });
  } else {
    
    productInfo.variants.forEach(function (variant) {
      if (
        variant.option1.toLowerCase() == quantity.toLowerCase() &&
        variant.option2.toLowerCase() == groundType.toLowerCase()
      ) {
        variantID = variant.id;
        orderSummaryContent(variant.featured_image.src, variant.price);
      }
    });
  }
}

function orderSummaryContent(image, price) {
let getSubscriptionPrice = document.querySelector(".subscription-order--summary-info").getAttribute("subscription_price");
let stringSubscriptionPrice= Number(getSubscriptionPrice)/100;
console.log(stringSubscriptionPrice)

let Shipping_Flat_text = document.querySelector(".subscription-order--summary-info").getAttribute("Shipping_Flat_text");
let numericShipping = Shipping_Flat_text.replace('$', '').trim();
let stringShippingPrice = Number(numericShipping);
console.log(stringShippingPrice);
const divsWithCharge = document.querySelectorAll('.chargeShipping');
if (divsWithCharge.length > 0) {
  // Loop over each div with the class .chargeShipping
  divsWithCharge.forEach(div => {
    // Step 1: Find the closest parent element with the class .choose-roasting-quantity
    const getParent = div.closest(".choose-roasting-quantity");

    if (getParent) {
      // Step 2: Find the parent of .choose-roasting-quantity
      const parentDiv = getParent.parentElement;

      // Log the parentDiv to ensure you're targeting the right element
      console.log("parentDiv:", parentDiv);

      // Step 3: Search for the element with the specific ID globally (outside of parentDiv)
      const specificElement = document.querySelector('.order_summary_subscription');

      if (specificElement) {
        // Step 4: Find the child with the class .subscription-order--summary-item inside the specificElement
        const summaryItem = specificElement.querySelector('.subscription-order--summary-item .subscription-order--summary-info .shippingcharge');
        const summaryItem_noShipping = specificElement.querySelector('.subscription-order--summary-item .subscription-order--summary-info .noShippingCharge');
        
        if (summaryItem && summaryItem_noShipping) {
          summaryItem.style.display = "flex";
          summaryItem_noShipping.style.display = "none";
          console.log('Found .subscription-order--summary-item with shipping charge:', summaryItem);
        }
      } else {
        console.log('Element with the ID not found globally.');
      }
    } else {
      console.log('No parent with class .choose-roasting-quantity found for chargeShipping');
    }
  });
if(stringSubscriptionPrice){
  price = (price / 100).toFixed(2);
  let discount = price * stringSubscriptionPrice; // 5% discount
  let finalPrice = price - discount + stringShippingPrice; 
  let beforeDiscount=price - discount;
  beforeDiscount= beforeDiscount.toFixed(2)
  finalPrice=finalPrice.toFixed(2)
   document
    .querySelector(".subscription-order--summary-product--image")
    .setAttribute("src", image);
  document
    .querySelectorAll(".subscription-order--summary-product--price")
    .forEach(function (curr) {
      curr.innerText = `$${beforeDiscount}`;
    });
    document
    .querySelectorAll(".subscription-order--summary-product--price.total_subscription")
    .forEach(function (curr) {
      curr.innerText = `$${finalPrice}`;
    });
}
else{
  price = (price / 100).toFixed(2);
  console.log("Shipping_Flat_text"+Shipping_Flat_text)
  let finalPrice = Number(price) + Number(stringShippingPrice);
  console.log(finalPrice)
  document
    .querySelector(".subscription-order--summary-product--image")
    .setAttribute("src", image);
  document
    .querySelectorAll(".subscription-order--summary-product--price")
    .forEach(function (curr) {
      curr.innerText = `$${price}`;
    });
    document
    .querySelectorAll(".subscription-order--summary-product--price.total_subscription")
    .forEach(function (curr) {
      curr.innerText = `$${finalPrice}`;
    });

}
} else {
  const divsWithNoCharge = document.querySelectorAll('.nochargeShipping');
  
  // Loop over each div with the class .nochargeShipping
  divsWithNoCharge.forEach(div => {
    // Step 1: Find the closest parent element with the class .choose-roasting-quantity
    const getParent = div.closest(".choose-roasting-quantity");

    if (getParent) {
      // Step 2: Find the parent of .choose-roasting-quantity
      const parentDiv = getParent.parentElement;

      // Log the parentDiv to ensure you're targeting the right element
      console.log("parentDiv:", parentDiv);

      // Step 3: Search for the element with the specific ID globally (outside of parentDiv)
      const specificElement = document.querySelector('.order_summary_subscription');

      if (specificElement) {
        // Step 4: Find the child with the class .subscription-order--summary-item inside the specificElement
        const summaryItem = specificElement.querySelector('.subscription-order--summary-item .subscription-order--summary-info .shippingcharge');
        const summaryItem_noShipping = specificElement.querySelector('.subscription-order--summary-item .subscription-order--summary-info .noShippingCharge');
        
        if (summaryItem_noShipping && summaryItem) {
          summaryItem_noShipping.style.display = "flex";
          summaryItem.style.display = "none";
          console.log('Found .subscription-order--summary-item with no shipping charge:', summaryItem_noShipping);
        }
      } else {
        console.log('Element with the ID not found globally.');
      }
    } else {
      console.log('No parent with class .choose-roasting-quantity found for nochargeShipping');
    }
  });
  if(stringSubscriptionPrice){
  price = (price / 100).toFixed(2);
    let discount = price * stringSubscriptionPrice; // 5% discount
    let beforeDiscount=price - discount;
    beforeDiscount=beforeDiscount.toFixed(2)
    document
      .querySelector(".subscription-order--summary-product--image")
      .setAttribute("src", image);
    document
      .querySelectorAll(".subscription-order--summary-product--price")
      .forEach(function (curr) {
        curr.innerText = `$${beforeDiscount}`;
      });
      document
      .querySelectorAll(".subscription-order--summary-product--price.total_subscription")
      .forEach(function (curr) {
        curr.innerText = `$${beforeDiscount}`;
      });
  }
  else{
  price = (price / 100).toFixed(2);
  document
    .querySelector(".subscription-order--summary-product--image")
    .setAttribute("src", image);
  document
    .querySelectorAll(".subscription-order--summary-product--price")
    .forEach(function (curr) {
      curr.innerText = `$${price}`;
    });
    document
    .querySelectorAll(".subscription-order--summary-product--price.total_subscription")
    .forEach(function (curr) {
      curr.innerText = `$${price}`;
    });
  }
  
}


  // price = (price / 100).toFixed(2);
  // document
  //   .querySelector(".subscription-order--summary-product--image")
  //   .setAttribute("src", image);
  // document
  //   .querySelectorAll(".subscription-order--summary-product--price")
  //   .forEach(function (curr) {
  //     curr.innerText = `$${price}`;
  //   });
}

document
  .querySelector("#subscription--add-to-cart")
  .addEventListener("click", function () {
    buildCart(variantID);

    if (window.isCustomer != "true") {
      var d = new Date();
      d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * 30);
      document.cookie = `isLoggedIn = false;path=/cart;expires=${d.toGMTString()}`;
    }
  });

function buildCart(id) {
  document.querySelector("#subscription--add-to-cart").innerText =
    "Subscribing";
  const cartObject = {
    items: [
      {
        id: id,
        quantity: 1,
        selling_plan: selling_plan,
        properties: {
          "Gift Message": giftMessage,
        },
      },
    ],
  };
  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },

    body: JSON.stringify(cartObject),
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (json) {
      if (json.staus && json.status !== 200) {
        console.log(error);
      } else {
        document.querySelector("#subscription--add-to-cart").innerText =
          "Subscribe";
        if (window.isCustomer != "true") {
          window.location.href = "/account/login";
        } else {
          window.location.href = "https://www.domacoffee.com";
        }
      }
    });
}

document
  .querySelector(".homepage-featured-content-wrapper .homepage-section-btn")
  .addEventListener("click", function (e) {
    e.preventDefault();
    window.scrollTo({
      top:
        document.querySelector(".subscription-text-with-image-overlay")
          .offsetTop -
        document.getElementsByClassName("header-section")[0].offsetHeight,
      left:
        document.querySelector(".subscription-text-with-image-overlay")
          .offsetTop -
        document.getElementsByClassName("header-section")[0].offsetHeight,
      behavior: "smooth",
    });
  });
